module.exports = __webpack_public_path__ + "static/media/find-500-differences.934aa201.jpg";